import { useStore } from 'zustand';
import { useGridStoreApiOptional } from './GridStoreProvider';
import { emptyGridStore } from './gridStore';

interface StoreBackedGridItem {
  skuId?: string;
  orderItemQuantity?: number;
}

interface UseStoreBackedGridParams<TItem extends StoreBackedGridItem> {
  combinationKey?: string;
  grid: TItem[];
}

export const useStoreBackedGrid = <TItem extends StoreBackedGridItem>({
  combinationKey,
  grid,
}: UseStoreBackedGridParams<TItem>): TItem[] => {
  const api = useGridStoreApiOptional();
  const isStoreBacked = !!api && !!combinationKey;

  const combinationCells = useStore(api ?? emptyGridStore, (state) =>
    combinationKey ? state.cells[combinationKey] : undefined,
  );

  if (!isStoreBacked || !combinationKey) {
    return grid;
  }

  return grid.map((gridItem) => {
    if (!gridItem.skuId) {
      return gridItem;
    }
    const quantity = combinationCells?.[gridItem.skuId]?.quantity ?? 0;
    if (quantity === (gridItem.orderItemQuantity ?? 0)) {
      return gridItem;
    }
    return { ...gridItem, orderItemQuantity: quantity };
  });
};
